<template>
    <div id="content" v-if="entity">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"/>

        <form autocomplete="off">
            <div class="inner">
                <p class="paging">
                    <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
                </p>
                <p class="buttons">
                    <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                       @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
                </p>
                <h1>{{ entity.name }}</h1>
            </div>
            <div class="responsiveTabs">
              <div class="tabs_content">
              <section>
                <div class="field_left">
                    <p>
                        <text-input id="name" v-model="entity.name" :required="true" :is-editable="$_updateActionAllowed">
                            <translate class="translate">Název</translate>
                        </text-input>
                    </p>
                    <p>
                        <select-box
                            id="device_type"
                            v-model="entity.id_device_type"
                            :options="deviceTypeOptions"
                            :is-editable="$_updateActionAllowed"
                        >
                            <translate class="translate">Typ zařízení</translate>
                        </select-box>
                    </p>
                </div>
              </section>
              <section>
                <div class="status">
                  <h2>Predikáty</h2>
                  <a class="add" href="#" title="Přidat predikát" @click.prevent="addPredicate">Přidat predikát</a>
                </div>
                <table>
                  <tr v-for="(_, index) in entity.predicates" :key="index">
                    <td
                        class="first_data"
                        data-th="Predikát"
                    >
                      <textarea-input
                          :id="'predicate_' + index"
                          v-model="entity.predicates[index]"
                          :rows="3"
                          :is-editable="$_updateActionAllowed"
                      />
                    </td>
                    <td class="no_padding edit">
                      <a v-if="$_updateActionAllowed" class="btn btn_action btn_delete"
                         @click.prevent="removePredicate(index)" v-translate>Odebrat</a>
                    </td>
                  </tr>
                </table>
              </section>
              </div>
              <section class="buttons">
                  <p>
                      <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
                      <input
                          v-if="$_updateActionAllowed"
                          type="submit"
                          :value="'Uložit' | translate"
                          class="btn"
                          @click.prevent.stop="submitForm()">
                  </p>
              </section>
              </div>
        </form>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: "DeviceTypeEvaluationDetail",
    mixins: [detailActions],
    data() {
        return {
            moduleName: 'deviceTypeEvaluations',
            entityName: 'device_type_evaluation',
            deviceTypeOptions: [],
        }
    },
    created(DeviceTypeEvaluationService, DeviceTypeService) {
        this.entityService = DeviceTypeEvaluationService
        DeviceTypeService.getEntitiesForSelectBox().then(data => {
            this.deviceTypeOptions = data.device_types.map(dt => ({ id: dt.id, text: dt.name })) || []
        })
        this.getEntity()
    },
    methods: {
        addPredicate() {
            this.entity.predicates = [...(this.entity.predicates || []), '']
        },
        removePredicate(index) {
            this.entity.predicates = this.entity.predicates.filter((_, i) => i !== index)
        },
        filterFormParams(params) {
            return {
                name: params.name,
                id_device_type: params.id_device_type,
                predicates: params.predicates,
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypeEvaluations/DeviceTypeEvaluationDetail.vue